import signalr from './signalr';
import {RouteRecordRaw} from 'vue-router';

export default [{
    path: '/signalr',
    name: 'signalr',
    component: signalr,
}] as RouteRecordRaw[];
